import { render, staticRenderFns } from "./PersonalList.vue?vue&type=template&id=40062c86&"
import script from "./PersonalList.vue?vue&type=script&lang=js&"
export * from "./PersonalList.vue?vue&type=script&lang=js&"
import style0 from "./PersonalList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalList.vue"
export default component.exports